import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--extranarrow _mb-6 _mt-6 js-main-content" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "_ml-1" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "_ml-1" }
const _hoisted_6 = { class: "_mt-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_navigation = _resolveComponent("project-navigation")
  const _component_project_update = _resolveComponent("project-update")
  const _component_project_recommendations = _resolveComponent("project-recommendations")
  const _component_comments_section = _resolveComponent("comments-section")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { id: "navigation" }, null, -1 /* CACHED */)),
    _createVNode(_component_project_navigation, {
      items: $props.navigation.items
    }, null, 8 /* PROPS */, ["items"]),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("a", {
        href: $props.goBackUrl,
        class: "gfu-link gfu-link--block gfu-link--nofx _tc--accent _mb-6"
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fa fa-chevron-left" }, null, -1 /* CACHED */)),
        _createElementVNode("span", _hoisted_3, _toDisplayString($props.goBackLabel), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_2),
      _createVNode(_component_project_update, {
        "show-content": true,
        update: $props.update,
        "is-logged-in": $props.isLoggedIn
      }, null, 8 /* PROPS */, ["update", "is-logged-in"]),
      _createElementVNode("a", {
        href: $props.goBackUrl,
        class: "gfu-link gfu-link--block gfu-link--nofx _tc--accent _mt-6"
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fa fa-chevron-left" }, null, -1 /* CACHED */)),
        _createElementVNode("span", _hoisted_5, _toDisplayString($props.goBackLabel), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_4),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_project_recommendations, {
          quantity: 12,
          source: "projectUpdate",
          "excluded-project-ids": [$props.projectId]
        }, null, 8 /* PROPS */, ["excluded-project-ids"])
      ]),
      ($props.showComments)
        ? (_openBlock(), _createBlock(_component_comments_section, _normalizeProps(_mergeProps({ key: 0 }, $props.comments)), null, 16 /* FULL_PROPS */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}